import * as _ from 'lodash';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { IDiagnosticOrder } from '@ispm/test/interfaces/diagnostic-order.interface';
import { IWorkflowRequest } from '@ispm/workflow/interfaces/workflow-request.interface';
import { Observable } from 'rxjs/Observable';
import { QcResultCategory } from '../../interfaces/qcresults.interface';
import { QcService } from '../../services/qc.service';
import { TestService } from '@ispm/dashboard/test/services/test.service';
import {ActivatedRoute, Router} from "@angular/router";
import { RouterManagerService } from '@ispm/core/services/router-manager.service';

@Component({
  selector: 'gen-qc-results',
  templateUrl: './qc-results.component.html',
  styleUrls: ['./qc-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class QcResultsComponent implements OnInit {
  public iconToggle: any = { };
  public revisionId: string;
  public testId: string;

  public testConfig: any;
  public f: any;
  public relatedQcSamples: Observable<RelatedControlTest[]>;
  public warningInQcResults: boolean = false;
  public failuresInQcResults: boolean = false;
  public qcResults: Observable<any>;


  constructor(private activatedRoute: ActivatedRoute,
              private _qcService: QcService,
              public testService : TestService,
              private cd: ChangeDetectorRef,
              private router: Router,
              private routerManagerService: RouterManagerService) {
    this.revisionId = activatedRoute.parent.snapshot.params.revisionId;
    this.testId = activatedRoute.parent.snapshot.params.testId;
    this.qcResults = _qcService.getActiveResults()
      .filter(res => !!res)
      .take(1)
      .map(results => {
        _.forIn(results, (qcCategory: QcResultCategory, qcCategoryName: string) => {
          if (qcCategory.containsFailures) {
            this.failuresInQcResults = true;
          }

          if (qcCategory.containsWarnings) {
            this.warningInQcResults = true;
          }
        });

        return results;
      });
  }

  ngOnInit() {
    this.testConfig = this.testService.testConfiguration;
    this.f = this.QcFilter.bind(this);
    this.prepareRelatedControlSamples();
  }

  QcFilter(category) {
    return this.testConfig.qcCategoryExclude ? !this.testConfig.qcCategoryExclude.includes(category.key) : true;
  }

  goToTest(patientId, testId, activeRevisionId, lastRevisionId) {
    this.router.navigate(['/Pathologist'],
      { queryParams: {
        patientId: patientId, testId: testId,
        revisionId: activeRevisionId === 'None' ? lastRevisionId : activeRevisionId
      }
      });
  }

  private prepareRelatedControlSamples() {
    this.relatedQcSamples = this._qcService.getRelatedQCTests(this.testId, this.testConfig.id);
  }

  goToControlSampleTest(data: RelatedControlTest, index: number) {
    const orderId = data.orders[index].id;
    const request = data.orders[index].workflowRequest.toString();
    const workflow = data.requests.find(v => v.id === request && v.revisions.length > 0);
    const revisionId = workflow ? workflow.revisions[0].id : undefined;
    const testId = data.orders[index].workflowRequest;

    this.router.navigate(['/Test', orderId,testId,revisionId], { queryParams: this.routerManagerService.queryParameters, queryParamsHandling: 'preserve' });
  }

  prepareClassName(tagValue: string) {
    return tagValue ? tagValue.toLowerCase().replace(' ', '_') : '';
  }

  trackByFn(item, index) {
    return item ? item.key : index;
  }
}

export interface RelatedControlTest {
  requests: IWorkflowRequest[];
  orders: IDiagnosticOrder[];
}

